import { render, staticRenderFns } from "./Contribution.vue?vue&type=template&id=15f44e21&scoped=true"
import script from "./Contribution.vue?vue&type=script&lang=ts"
export * from "./Contribution.vue?vue&type=script&lang=ts"
import style0 from "./Contribution.vue?vue&type=style&index=0&id=15f44e21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f44e21",
  null
  
)

export default component.exports